import $ from 'jquery';

const saveDraftAPI = (draftId, title, category_id, folder_id, owner_id, editor_state, body) => $.ajax({
    type: 'PUT',
    url: `/api/drafts/${draftId}`,
    data: {
        title, category_id, folder_id, owner_id, editor_state, body
    },
});

export default saveDraftAPI;
